import React from "react";
import { BookingCard } from "../../components/BookingCard/BookingCard";
import {
  BookingContainer,
  BottomContainer,
  ButtonContainer,
  Description,
  Divider,
  GalleryContainer,
  LeftContainer,
  LocationDiv,
  MainTitle,
  MainWrapper,
  SecondaryTitle,
  TopContainer,
} from "./styles";
import { getResourceById } from "../../services/resources/getResources";
import { useParams } from "react-router-dom";
import { ImageMosaic } from "../../components/ImageMosaic";
import { TextWithIcon } from "../../components/TextWithIcon";
import FavoriteButton from "../../components/FavoriteButton/FavoriteButton";
import Spinner from "../../components/Spinner/Spinner";
import { SingleGallery } from "../../components/SingleGallery";

export const Details = () => {
  // ------------------- JWT -------------------
  const jwt = localStorage.getItem('jwt');

  const { id } = useParams();
  const resourceId = id || "No ID available";

  // ------------------- STATES -------------------
  const [resource, setResource] = React.useState<any>({});

  const [loadingResource, setLoadingResource] = React.useState(false);
  const [loadingDetails, setLoadingDetails] = React.useState(true);
  const [img, setImg] = React.useState<any>([]); // Favourites list state
  const [place, setPlace] = React.useState<any>("");
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  // ------------------- GET RESOURCES FROM API -------------------
  const getResource = async () => {
    await getResourceById(parseInt(resourceId), jwt!)
      .then((res) => {
        if (res && res.data) {
          setResource(res.data);
          setImg(res.data.resource.images);
          const location = res.data.resource.location
          const parts = location.split(", ");
          parts[3] = "Piso " + parts[3];
          parts[4] = "Salón " + parts[4];
          const result = parts.slice(1).join(", ");
          setPlace(result)
          if (parts[2] === "N/A" || parts[2] === "Sin edificio asignado") {
            setPlace(parts[1])
          }
        }
      })
      .catch((err) => {
        console.log(err, "err");
      });
    setLoadingDetails(false);
  };

  // ------------------- USE EFFECT -------------------
  React.useEffect(() => {
    setLoadingResource(true);
    getResource();
  }, []);

  React.useEffect(() => {
    getResource();
  }, []);

  React.useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <MainWrapper>
      {loadingDetails ? (
        <Spinner /> 
      ) : (
        <>
          <TopContainer>
            <MainTitle>
              {resource.resource?.name}
            </MainTitle>
            <ButtonContainer>
              <FavoriteButton resourceId={parseInt(resourceId)} type={windowWidth <= 400 ? 'icon' : 'complete'}/>
            </ButtonContainer>
          </TopContainer>
          {windowWidth >= 400 ? (
          <ImageMosaic
            width="100%"
            images={
              img.map((img: any) => img.url)
            }
          />
          ) : (
            <GalleryContainer>
            <SingleGallery 
            images={img.map((img: any) => img.url)}
            width="100%"
            height="100%"
            />
            </GalleryContainer>
          )}
          <BottomContainer>
            <LeftContainer>
              <SecondaryTitle>{resource.resource?.name}</SecondaryTitle>
              <Divider />
              <Description>
                {resource.resource?.description}
              </Description>
              <LocationDiv>
                <TextWithIcon
                  text={place}
                  size="Medium"
                />
              </LocationDiv>
            </LeftContainer>
            <BookingContainer>
              <BookingCard width="450px" />
            </BookingContainer>
          </BottomContainer>
        </>
      )}
    </MainWrapper>
  );
};

export default Details;
